var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"elements-list"},_vm._l((_vm.filteredElements),function(element){return _c('ElementsListItem',{key:element.id,attrs:{"element":element,"filtered-search-elements":_vm.filteredSearchElements},on:{"select":function($event){return _vm.$emit('select', $event)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }